import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Container, FormGroup, Label, Input, Col, ModalBody, Modal, ModalHeader } from "reactstrap";
import CreateTableComponent from '../share/CreateTableComponent';
import { Formik, Form, Field } from "formik";
import { Loading } from "../share/loading";
import * as Yup from "yup";
import { NumberWithCommas } from "../share/NumberWithCommas";
import "../share/form.css";
import Swal from "sweetalert2";
import { FormikSelect } from "../share/FormikSelect";
import { GetVMdDept } from "../share/api/MasterDataApi";
import * as XLSX from "xlsx";
import { FaSistrix } from "react-icons/fa";
// import DataRegisterComponent from "../../share/DataRegisterComponent";
export function CreateSupportAnnounce4Component() {
    const formikRef = useRef(null); // ✅ ใช้ useRef เพื่อดึง setFieldValue ภายนอก
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    // ดึง cookie มาใช้
    const user = JSON.parse(localStorage.getItem("userData"));
    let supportId = searchParams.get("req");
    let supportTypeId = searchParams.get("type"); //type1 : ประกาศ 4, type2: ประกาศ 5 , type3 : ประกาศ 11
    let getCurrentYear = new Date().getFullYear();
    const [listregisterOptions, setListRegisterOptions] = useState([]);
    const [selectRegisterId, setSelectRegisterId] = useState(0);
    // console.log("selectRegisterId", selectRegisterId);
    //ข้อมูลการลงทะเบียน
    const [userProfile, setUserProfile] = useState(null);
    // console.log(userProfile);
    const [userAuthRegister, setUserAuthRegister] = useState([]);
    // console.log(userAuthRegister);

    const [currentSupportForm, setCurrentSupportForm] = useState(null);
    const [loading, setLoading] = useState(false);
    const [conditionData, setConditionData] = useState([]);
    // state ดึงข้อมูลจาก master data
    const [deptsData, setDeptsData] = useState([]);
    const [titleName, setTitleName] = useState([]);

    // สำหรับใส่ที่อยู่สถานที่ตั้งศูนย์ดำเนินการทดสอบ
    const [testProvince, setTestProvince] = useState([]);
    const [testAmphur, setTestAmphur] = useState([]);
    const [testTumbon, setTestTumbon] = useState([]);

    const [certificate24, setCertificate24] = useState("");
    const [certificate24Person, setCertificate24Person] = useState([]);
    const [certificate24Data, setCertificate24Data] = useState([]);
    // console.log("certificate24Data", certificate24Data);
    const [setConditionDate] = useState(null);
    const [calculateAmount, setCalculateAmount] = useState(0);

    const [listTestPerson, setListTestPerson] = useState([]);
    const [modalListTestPerson, setModalListTestPerson] = useState(false);
    const ToggleModalListTestPerson = () => setModalListTestPerson(!modalListTestPerson);
    // console.log("calculateAmount", calculateAmount);
    useEffect(() => {
        GetVMdDept({ setDeptsData, setLoading })
        GetProvince();
        GetTitleName();
        // getProfile();
    }, []);

    const COLUMNS = [
        { Header: "ลำดับ", accessor: (_row, i) => i + 1 },
        { Header: "ชื่อ-นามสกุล", accessor: "names", Cell: ({ row }) => <div className="d-flex justify-content-start">{row.original.names}</div> },
        { Header: "สาขาอาชีพ", accessor: "lawOccupationName", Cell: ({ row }) => <div className="d-flex justify-content-start">{row.original.lawOccupationName}</div> },
        { Header: "สาขา", accessor: "testOccupationName", Cell: ({ row }) => <div className="d-flex justify-content-start">{row.original.testOccupationName}</div> },
        { Header: "ระดับ", accessor: "level", Cell: ({ row }) => <div className="d-flex justify-content-end">{row.original.level}</div> },
        {
            Header: "เลขที่ใบเสร็จรับเงิน", accessor: "personId",
            Cell: ({ row }) => <div className="d-flex justify-content-start">{row.original.personId}</div>
        },

    ];

    const getProfile = async () => {
        try {
            let formData = new FormData();
            // console.log("selectRegisterId", selectRegisterId);
            formData.append("registerId", selectRegisterId ?? 0)
            const res = await fetch("/api/Profile/getProfile", {
                method: "POST",
                headers: { 'token': user.token },
                body: formData
            })
            const resJson = await res.json();

            resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
            setUserProfile(resJson.dataenum);
            setUserAuthRegister(resJson.dataenum.authRegister);
            if (supportId == "0") {
                // ✅ ใช้ setFieldValue ผ่าน formikRef
                formikRef.current?.setFieldValue("deptId", resJson.dataenum.deptId);
                formikRef.current?.setFieldValue("coordinateName", resJson.dataenum.contactorName);
                formikRef.current?.setFieldValue("coordinatePhone", resJson.dataenum.contactorPhone);
                formikRef.current?.setFieldValue("coordinateMobile", resJson.dataenum.phone);
                formikRef.current?.setFieldValue("coordinateFax", resJson.dataenum.fax);
                formikRef.current?.setFieldValue("coordinateEmail", resJson.dataenum.email);
            }

        } catch (e) {
            // console.log("err", e)
        }
    };

    useEffect(() => {
        getProfile();
    }, [selectRegisterId])

    useEffect(() => {
        const GetListRegister = async () => {
            try {
                const res = await fetch("/api/OfficerBorrowing/listRegister", {
                    method: "GET",
                    headers: { 'token': user.token },
                })
                const resJson = await res.json();
                setListRegisterOptions(resJson.dataenum);
            } catch (e) {
                // console.log("err", e)
            }
        }
        GetListRegister();
    }, [])

    useEffect(() => {
        GetAmphur(userProfile?.address?.provinceCode);
        GetTumbon(userProfile?.address?.provinceCode, userProfile?.address?.amphurCode);
    }, [userProfile])

    async function GetAmphur(provinceCode) {
        let postData = new FormData();
        postData.append("provinceCode", provinceCode);

        try {
            const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                method: "POST",
                body: postData
            });
            const amphurData = await responseAmphur.json()
            setTestAmphur(amphurData.dataenum);
            // console.log(amphurData.dataenum);

        } catch (err) {
            // console.log("err =>" + err);
        }
    }

    async function GetTumbon(provinceCode, amphurCode) {
        let postData = new FormData();
        postData.append("provinceCode", provinceCode);
        postData.append("amphurCode", amphurCode);
        try {
            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                method: "POST",
                body: postData
            });
            const tumbonData = await responseTumbon.json()
            setTestTumbon(tumbonData.dataenum);

        } catch (err) {
            // console.log("err =>" + err);
        }
    };

    const ReplaceNullWithEmptyString = (obj) => {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] === null) {
                    obj[key] = '';
                }
            }
        }
        return obj;
    }
    // เอามาแสดงเฉยๆ
    const checkCertificate24 = async (certificate24) => {
        // console.log("certificate24", certificate24);
        try {
            let postData = new FormData()
            // console.log(certificate24)
            postData.append("certificate24No", certificate24)

            let res = await fetch(`api/SupportForm/checkDataAnnounceFour`, {
                method: "POST",
                body: postData
            })

            let resJson = await res.json();
            // console.log("resJson.status", resJson.status)
            if (resJson.dataenum.length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "ไม่พบข้อมูล",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            } else {
                setCertificate24Data(resJson.dataenum)
            }

        } catch (e) {
            // console.log(e)
        }
    }

    //เอามาเพื่อ check ว่า จำนวนทั้งหมด และวันที่เกินมั้ย 
    const checkTotalPerson24 = async (conditionData, certificate24) => {
        try {
            let postData = new FormData()
            // console.log(certificate24)
            postData.append("certificate24No", certificate24)

            let res = await fetch(`api/SupportForm/checkPersonAnnounceFour`, {
                method: "POST",
                body: postData
            })

            let resJson = await res.json();
            // console.log("resJson", resJson.dataenum);
            // console.log("resJson.status", resJson.status)
            if (resJson.dataenum.length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "ไม่พบข้อมูล",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            } else {

                setCertificate24Person(resJson.dataenum)
                let conditionOne;
                let conditionTwo;
                // let conditionDate;
                conditionData.map((condition) => {
                    conditionOne = condition.condition1;
                    conditionTwo = condition.condition2;
                })
                // console.log("conditionOne", conditionOne);
                // console.log("conditionTwo", conditionTwo);
                let total = resJson.dataenum.map(({ total }) => total).join().toString();
                // console.log("before total", total);
                total = Number(total)
                // console.log("after total", total);


                if (total > 100) {
                    let base = 100;
                    let baseCalculate = total - base;
                    // console.log("baseCalculate", baseCalculate);
                    let moreExcess = baseCalculate * Number(conditionTwo);
                    // console.log("moreExcess", moreExcess);
                    let totalSummary = Number(conditionOne) + moreExcess;
                    // console.log("totalSummary", totalSummary);
                    setCalculateAmount(totalSummary)
                    // if (checkDate) {
                    //   setCalculateAmount(0)
                    // } else {
                    //   console.log("totalSummary", totalSummary)
                    //   setCalculateAmount(totalSummary)
                    // }

                } else {
                    Swal.fire({
                        icon: "error",
                        title: "คุณไม่มีสิทธิ์ขอรับเงินช่วยเหลือหรืออุดหนุน",
                        text: "",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            }

        } catch (e) {
            // console.log(e)
        }
    }

    const getCondition = async () => {
        try {
            let res = await fetch(`api/SupportForm/getConditionSupport/${1}`)
            let resJson = await res.json();
            // setConditionData(resJson.dataenum);
            let [firstArray] = resJson.dataenum;
            setConditionDate(firstArray.conditionDate);
            return resJson.dataenum;
        } catch (e) {
            // console.log('err => ', e)
        }
    }

    useEffect(() => {
        getConditionSupport();
    }, [])

    const getConditionSupport = async (e) => {

        try {
            let res = await fetch(`api/SupportForm/getConditionSupport/${1}`)
            let resJson = await res.json();
            // console.log(resJson.dataenum);
            setConditionData(resJson.dataenum);

        } catch (e) {
            // console.log('err => ', e)
        }
    }

    const handleExportTestPersonExcel = () => {
        if (!listTestPerson.length) {
            Swal.fire("ไม่มีข้อมูลสำหรับส่งออก", "", "warning");
            return;
        }

        const aoa = [
            [
                "ลำดับ",
                "ชื่อ-นามสกุล",
                "สาขาอาชีพ",
                "สาขา",
                "ระดับ",
                "เลขที่ใบเสร็จรับเงิน",
            ],
        ];

        listTestPerson.forEach((r, i) => {
            aoa.push([
                i + 1,
                r.names || "-",
                r.lawOccupationName || "-",
                r.testOccupationName || "-",
                r.level || "-",
                r.personId || "-",
            ]);
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(aoa);

        ws["!cols"] = [
            { wch: 6 },
            { wch: 30 },
            { wch: 30 },
            { wch: 25 },
            { wch: 25 },
            { wch: 25 },
        ];

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            "รายชื่อผู้ผ่านการทดสอบ"
        );

        XLSX.writeFile(
            wb,
            "รายชื่อผู้ผ่านการทดสอบมาตรฐานฝีมือแรงงาน.xlsx"
        );
    };

    //ดึงข้อมูลแบบฟอร์มอุดหนุน
    useEffect(() => {
        const GetCurrentSupportForm = async () => {
            if (supportId !== "0") {
                let postData = new FormData();
                postData.append("supportId", Number(supportId));
                postData.append("supportTypeId", Number(supportTypeId));
                setLoading(true);
                try {
                    let res = await fetch("/api/SupportForm/getSupportFormData", {
                        method: "POST",
                        body: postData
                    })
                    let resJson = await res.json();
                    // console.log("GetCurrentSupportForm", resJson.dataenum);
                    resJson.dataenum["customerTypeId"] = Number(user.roldId);
                    resJson.dataenum["registerId"] = Number(user.registerId);
                    resJson.dataenum["term"] = true;
                    let listCondition = await getCondition(1)
                    resJson.dataenum["announce"] = "4";
                    resJson.dataenum["certificate24"] = resJson.dataenum.testLicense24No;

                    setCertificate24(resJson.dataenum.testLicense24No);
                    await checkCertificate24(resJson.dataenum.testLicense24No) // ขอ data
                    await checkTotalPerson24(listCondition, resJson.dataenum.testLicense24No) //ขอจำนวนคนทั้งหมด
                    setCurrentSupportForm(ReplaceNullWithEmptyString(resJson.dataenum));
                    await GetAmphur(resJson.dataenum.testProvinceCode);
                    await GetTumbon(resJson.dataenum.testProvinceCode, resJson.dataenum.testAmphurCode)
                    setCalculateAmount(resJson.dataenum.amount);

                } catch (e) {
                    // console.log("err", e);
                } finally {
                    setLoading(false);
                }
            } else {
                return;
            }
        };
        GetCurrentSupportForm();
    }, [])

    useEffect(() => {
        async function getConditionFromAnnounce() {
            conditionData.map((data) => {
                // console.log("data", data);
                setConditionDate(data.conditionDate)
            })
        }
        getConditionFromAnnounce()
    }, [conditionData])

    // ดึง master data จังหวัด
    async function GetProvince() {
        setLoading(true);
        try {
            const responseProvince = await fetch("/api/MasterData/getProvince");
            const localtionData = await responseProvince.json();
            setTestProvince(localtionData.dataenum);
        } catch (e) {
            // console.log("err => " + e);
        } finally {
            setLoading(false);
        }
    }

    async function GetTitleName() {
        const res = await fetch("/api/MasterData/getTitle");
        const data = await res.json();
        setTitleName(data.dataenum);
    }


    const initialValues = {
        supportId: "0",
        roldId: "",
        registerId: Number(user.registerId),
        deptId: "",
        // supportTypeName: "ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน",
        supportTypeId: "1",
        announce: "4",
        checkAnnounceFourData: certificate24Data,
        customerTypeId: Number(user.roldId),
        authRegisterId: 0,
        certificate24: certificate24,
        coordinateName: "",
        coordinatePhone: "",
        coordinateMobile: "",
        coordinateFax: "",
        coordinateEmail: "",
        amount: calculateAmount,
        paymentName: "",
        fOtherPath: "",
        term: "",

    };

    const ShowListTestPersonAnnounce4 = () => (
        <Modal
            isOpen={modalListTestPerson}
            toggle={ToggleModalListTestPerson}
            backdrop={"static"}
            keyboard={false}
            size="xl"
            className="modal-bordered"
            centered
        >
            <ModalHeader toggle={ToggleModalListTestPerson}>
                รายชื่อผู้ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ
            </ModalHeader>
            <ModalBody>
                <div className="d-flex justify-content-end gap-2 mb-2">
                    <button
                        className="btn btn-outline-success btn-sm"
                        onClick={handleExportTestPersonExcel}
                    >
                        ส่งออก Excel
                    </button>

                </div>
                <CreateTableComponent
                    column={COLUMNS}
                    dataInput={listTestPerson}
                    showEntrie={true}
                    showPage={true}
                />
            </ModalBody>
        </Modal>
    );

    const onSubmit = async (values) => {

        if (calculateAmount === 0) {
            Swal.fire({
                icon: "info",
                title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
        } else {
            let postData = new FormData();
            if (values.announce === "4") {
                postData.append("testLicense24No", certificate24)
            }
            postData.append("amount", calculateAmount)
            Object.entries(values).forEach(([key, value]) => {
                postData.append(key, value);
            });

            try {
                let res = await fetch("/api/SupportForm/saveSupportForm", {
                    method: "POST",
                    body: postData,
                });

                let resJson = await res.json();
                // console.log(resJson.dataenum);

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate("/supporting/")
                        }
                    });
                } else if (resJson.status === 4) {
                    Swal.fire({
                        icon: "warning",
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                // console.log(e);
            }
        }
    };

    const authRegisterOptions = userAuthRegister?.map((item) => ({
        label: item.authFullName,
        value: item.authRegisterId
    })) || [];


    const toText = (v) => (v ?? "").toString().toLowerCase();

    const customFilter = (option, rawInput) => {
        const q = toText(rawInput);
        const d = option && option.data ? option.data : {};
        return [d.companyNo, d.customerNo, d.fullName].some((f) => toText(f).includes(q));
    };

    // สมมติ data มาจาก API
    const registerOptions = (listregisterOptions || []).map((x) => ({
        value: x.registerId, // เก็บค่า registerId
        // label: `${x.companyNo ?? "-"} | ${x.customerNo ?? "-"} | ${x.fullName ?? "-"}`,
        label: `${x.fullName ?? "-"}`,

        companyNo: x.companyNo ?? "",
        customerNo: x.customerNo ?? "",
        fullName: x.fullName ?? "",
    }));

    const validationSchema = Yup.object().shape({
        fOtherPath: Yup.mixed().nullable().when('file', {
            is: value => value !== undefined && value !== null,
            then: Yup.mixed()
                .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
                    return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
                })
                .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 1MB', value => {
                    const maxSize = 1000000;
                    return !value || value.size <= maxSize;
                }),
        }),
        certificate24: Yup.string().when("announce", {
            is: "4",
            then: Yup.string().required()
        }),
        deptId: Yup.string().required("กรุณาเลือกหน่วยงานที่ยื่นคำขอ"),
        coordinateName: Yup.string().required("กรุณากรอกชื่อผู้ประสานงาน"),
        coordinatePhone: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),
        coordinateMobile: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),
        coordinateFax: Yup.string().nullable(),
        coordinateEmail: Yup.string()
            .email("รูปแบบอีเมลไม่ถูกต้อง")
            .required("กรุณากรอกอีเมล"),
        amount: Yup.number().nullable(),
        announce: Yup.string().nullable().required("กรุณาเลือกประเภท"),
        paymentName: Yup.string().nullable().required("กรุณากรอก"),
        term: Yup.bool().oneOf([true], "กรุณายอมรับข้อตกลง"),
    });

    return (
        <Formik
            innerRef={formikRef} // ✅ ตรงนี้สำคัญ
            initialValues={supportId === "0" ? initialValues : currentSupportForm}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={supportId === "0" ? false : true}
        >
            {({ setFieldValue, values, touched, errors, handleBlur, handleChange, getFieldProps }) => {

                // console.log("values", values);
                // console.log("errors", errors);
                const findPersonalId = () => {
                    if (values.authRegisterId != 0) {
                        const found = userAuthRegister.find(item => item.authRegisterId == values.authRegisterId);
                        return found.authPersonalId
                    }
                }
                const COLUMNSANNOUNCE4 = [
                    {
                        Header: "ลำดับ",
                        accessor: (_row, i) => i + 1,
                    },
                    {
                        Header: "วันที่ได้รับใบอนุญาต",
                        accessor: "allowDate",
                    },
                    {
                        Header: "สาขาอาชีพ",
                        accessor: "lawOccupationName",
                    },
                    {
                        Header: "สาขา",
                        accessor: "testOccupationName",
                    },
                    {
                        Header: "ระดับ",
                        accessor: "personId",
                    },
                    {
                        Header: "จำนวนผู้เข้ารับการทดสอบทั้งหมด",
                        accessor: "amount",
                    },
                ];

                async function getListTestPersonAnnounce4() {
                    setLoading(true);
                    let postData = new FormData();
                    postData.append("certificate24No", certificate24)

                    try {
                        let res = await fetch("/api/Support/getListTestPersonAnnounce4ForUser", {
                            method: "POST",
                            body: postData,
                        });
                        const json = await res.json();
                        setListTestPerson(json.dataenum || []);
                    } catch (e) {
                        // console.log("err", e);
                    } finally {
                        setLoading(false);
                    }
                }

                // เอามาแสดงเฉยๆ
                const checkCertificate24 = async () => {
                    try {
                        let postData = new FormData()
                        // console.log(certificate24)
                        postData.append("certificate24No", certificate24)

                        let res = await fetch(`api/SupportForm/checkDataAnnounceFour`, {
                            method: "POST",
                            body: postData
                        })

                        let resJson = await res.json();
                        setFieldValue("announe", "4")
                        // console.log("resJson.status", resJson.status)
                        if (resJson.dataenum.length === 0) {
                            Swal.fire({
                                icon: "error",
                                title: "ไม่พบข้อมูล",
                                text: "",
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            });
                        } else {
                            setCertificate24Data(resJson.dataenum)
                        }

                    } catch (e) {
                        // console.log(e)
                    }
                }
                //เอามาเพื่อ check ว่า จำนวนทั้งหมด และวันที่เกินมั้ย 
                const checkTotalPerson24 = async () => {
                    try {
                        let postData = new FormData()
                        // console.log(certificate24)
                        postData.append("certificate24No", certificate24)

                        let res = await fetch(`api/SupportForm/checkPersonAnnounceFour`, {
                            method: "POST",
                            body: postData
                        })

                        let resJson = await res.json();
                        // console.log("resJson.status", resJson.status)
                        if (resJson.dataenum.length === 0) {
                            Swal.fire({
                                icon: "error",
                                title: "ไม่พบข้อมูล",
                                text: "",
                                confirmButtonColor: "#0A66C2",
                                confirmButtonText: "ตกลง",
                            });
                        } else {

                            setCertificate24Person(resJson.dataenum)
                            let conditionOne;
                            let conditionTwo;
                            // let conditionDate;
                            conditionData.map((condition) => {
                                conditionOne = condition.condition1;
                                conditionTwo = condition.condition2;
                            })

                            // console.log("conditionData", conditionData);

                            let total = resJson.dataenum.map(({ total }) => total).join().toString();
                            // console.log("before total", total);
                            total = Number(total)
                            // console.log("after total", total);


                            if (total > 100) {
                                let base = 100;
                                let baseCalculate = total - base;

                                let moreExcess = baseCalculate * Number(conditionTwo);
                                let totalSummary = Number(conditionOne) + moreExcess;
                                // console.log("totalSummary", totalSummary);
                                setCalculateAmount(totalSummary)
                                // if (checkDate) {
                                //   setCalculateAmount(0)
                                // } else {
                                //   console.log("totalSummary", totalSummary)
                                //   setCalculateAmount(totalSummary)
                                // }

                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: "คุณไม่มีสิทธิ์ขอรับเงินช่วยเหลือหรืออุดหนุน",
                                    text: "",
                                    confirmButtonColor: "#0A66C2",
                                    confirmButtonText: "ตกลง",
                                });
                            }
                        }

                    } catch (e) {
                        // console.log(e)
                    }
                }

                return (
                    <>
                        <ShowListTestPersonAnnounce4 />
                        <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                            {!loading ? (
                                <div className="form-border">
                                    <Form className="p-5 mb-4">

                                        <Label className="customer-type text-center px-5">
                                            คำขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน
                                            พ.ศ. 2545 กรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน
                                        </Label>

                                        <FormGroup className="mb-3">
                                            <Label htmlFor="establishmentId" className="fw-semibold">
                                                เลือกผู้ใช้งานที่จะลงทะเบียนให้ <span className="require-input">*</span>
                                            </Label>

                                            <Select
                                                options={registerOptions}
                                                filterOption={customFilter}
                                                placeholder="ค้นหาโดย เลขทะเบียนนิติบุคคล 13 หลัก, เลขสถานประกอบการ 10 หลัก หรือ ชื่อสถานประกอบการ"
                                                isClearable
                                                noOptionsMessage={() => "ไม่พบข้อมูล"}
                                                onChange={(selected) => {
                                                    // console.log("selected.value", selected.value);
                                                    // selected = { value, label, companyNo, customerNo, fullName }
                                                    setSelectRegisterId(selected.value)
                                                    setFieldValue("registerId", selected ? selected.value : "");
                                                }}
                                                value={registerOptions.find(item => item.value == selectRegisterId)}
                                            />
                                        </FormGroup>
                                        {/* ปุ่มลงทะเบียนใหม่ */}
                                        {/* <div className="d-flex align-items-center mt-2">
                                        <span className="me-3 text-muted">
                                            หากยังไม่ได้ลงทะเบียนสถานประกอบการในระบบ
                                        </span>
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary rounded-pill px-4"
                                            onClick={() => navigate("/register-establishment")} // 🔧 route ปรับตามจริง
                                        >
                                            ลงทะเบียน
                                        </button>
                                    </div> */}

                                        {/* <Label className="mb-3 input-color">ข้อมูลผู้ขอเงินช่วยเหลือหรืออุดหนุน</Label> */}
                                        {/* <DataRegisterComponent /> */}
                                        <FormGroup className="mt-3">
                                            <Label for="dept">
                                                ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน

                                            </Label>
                                            <Col>
                                                <Input
                                                    className={"rounded-pill text-center input-color"}
                                                    type="text"
                                                    disabled
                                                    // name="authoriseName"
                                                    // id="authoriseName"
                                                    // placeholder="กรุณากรอกชื่อ-สกุล"
                                                    onBlur={handleBlur}
                                                    // onChange={(e) => {
                                                    //     handleChange(e);
                                                    // }}
                                                    value={userProfile?.licenseTestName ?? "-"}
                                                />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup className="mt-3">
                                            <Label for="dept">
                                                เลขทะเบียนนิติบุคคล
                                            </Label>
                                            <Col>
                                                <Input
                                                    className={"rounded-pill text-center input-color"}
                                                    type="text"
                                                    disabled
                                                    // name="authoriseName"
                                                    // id="authoriseName"
                                                    // placeholder="กรุณากรอกชื่อ-สกุล"
                                                    onBlur={handleBlur}
                                                    // onChange={(e) => {
                                                    //     handleChange(e);
                                                    // }}
                                                    value={userProfile?.customerNo ?? "-"}
                                                />
                                            </Col>
                                        </FormGroup>

                                        {/* <Label className="mb-3 input-color">กรุณากรอกรายละเอียดการขอเงินช่วยเหลือหรืออุดหนุน</Label> */}
                                        {/* input เลือกหน่วยงานที่จะยื่นคำขอ */}
                                        <FormGroup className="mt-3">
                                            <Label for="dept">
                                                ยื่นคำขอที่
                                                <span className="require-input">*</span>
                                                {touched.deptId && errors.deptId ? (
                                                    <span className="text-left text-danger mx-1">
                                                        {errors.deptId}
                                                    </span>
                                                ) : null}
                                            </Label>
                                            <Col>
                                                <Field
                                                    name="deptId"
                                                    component={FormikSelect}
                                                    options={deptsData}
                                                    placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                                />
                                            </Col>
                                        </FormGroup>


                                        {/* ผู้กระทำการแทน คำนำหน้าและชื่อ */}
                                        <FormGroup row>
                                            <Label for="titleId">
                                                โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ)
                                                <span className="require-input">*</span>
                                                {touched.authRegisterId &&
                                                    errors.authRegisterId ? (
                                                    <span className="text-left text-danger px-1">
                                                        {errors.authRegisterId}
                                                    </span>
                                                ) : null}

                                            </Label>
                                            <div className="d-flex justify-content-start ">
                                                <div className="flex-grow-1">
                                                    <Field
                                                        name="authRegisterId"
                                                        component={FormikSelect}
                                                        options={authRegisterOptions}
                                                        placeholder={<div className="input-color text-center">กรุณาเลือก</div>}
                                                    />
                                                </div>

                                            </div>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label for="titleId">
                                                เลขบัตรประจำตัวประชาชน

                                            </Label>

                                            <div className="d-flex justify-content-start ">
                                                <div className="flex-grow-1">
                                                    <Input
                                                        className="rounded-pill text-center input-color"
                                                        type="text"
                                                        name=""
                                                        id=""
                                                        disabled
                                                        value={findPersonalId()}
                                                    />

                                                </div>
                                            </div>
                                        </FormGroup>



                                        {/* ที่ตั้ง ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน */}
                                        <div className="pt-3">
                                            <Label for="">
                                                ที่ตั้ง ศูนย์ทดสอบมาตรฐานฝีมือแรงงาน
                                            </Label>
                                            {/* ที่อยู่ */}
                                            <div className="px-3 pt-4">
                                                <FormGroup row>
                                                    <Label for="testAddressNo" sm={2}>
                                                        เลขที่<span className="require-input">*</span>
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="testAddressNo"
                                                            name="testAddressNo"
                                                            disabled
                                                            type="text"
                                                            className={
                                                                touched.testAddressNo && errors.testAddressNo
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            // value={values?.testAddressNo}
                                                            value={userProfile?.address?.addressNo ?? "-"}
                                                        />
                                                    </Col>

                                                    <Label for="testMoo" sm={2}>
                                                        หมู่ที่
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="testMoo"
                                                            name="testMoo"
                                                            disabled
                                                            type="text"
                                                            className="rounded-pill text-center input-color"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            // value={values?.testMoo}
                                                            value={userProfile?.address?.moo ?? "-"}
                                                        />
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row>
                                                    <Label for="testSoi" sm={2}>
                                                        ซอย
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="testSoi"
                                                            name="testSoi"
                                                            disabled
                                                            type="text"
                                                            className={
                                                                touched.testSoi && errors.testSoi
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            // value={values?.testSoi}
                                                            value={userProfile?.address?.soi ?? "-"}

                                                        />
                                                    </Col>

                                                    <Label for="" sm={2}>
                                                        ถนน
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="testStreet"
                                                            name="testStreet"
                                                            disabled
                                                            type="text"
                                                            className={
                                                                touched.testStreet && errors.testStreet
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            // value={values?.testStreet}
                                                            value={userProfile?.address?.street ?? "-"}

                                                        />
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row>
                                                    <Label for="testProvinceCode" sm={2}>
                                                        จังหวัด<span className="require-input">*</span>
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="testProvinceCode"
                                                            name="testProvinceCode"
                                                            disabled
                                                            value={userProfile?.address?.provinceCode ?? "-"}
                                                            type="select"
                                                            className={
                                                                touched.testProvinceCode &&
                                                                    errors.testProvinceCode
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                        // onChange={(e) => {
                                                        //     handleChange(e);
                                                        //     GetTestAmphur(e);
                                                        //     setFieldValue("testAmphurCode", "กรุณาเลือกอำเภอ/เขต");
                                                        //     setFieldValue("testTumbonCode", "กรุณาเลือกตำบล/แขวง");
                                                        // }}
                                                        // value={values?.testProvinceCode}
                                                        >
                                                            <option defaultValue="กรุณาเลือกจังหวัด">
                                                                กรุณาเลือกจังหวัด
                                                            </option>
                                                            {testProvince?.map((province) => (
                                                                <option
                                                                    key={province.provinceCode}
                                                                    value={province.provinceCode}
                                                                >
                                                                    {province.provinceName}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </Col>

                                                    <Label for="testAmphurCode" sm={2}>
                                                        อำเภอ/เขต<span className="require-input">*</span>
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="testAmphurCode"
                                                            name="testAmphurCode"
                                                            disabled
                                                            type="select"
                                                            className={
                                                                touched.testAmphurCode &&
                                                                    errors.testAmphurCode
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            // onChange={(e) => {
                                                            //     handleChange(e);
                                                            //     GetTestTumbon(e);
                                                            //     setFieldValue(
                                                            //         "testTumbonCode",
                                                            //         "กรุณาเลือกตำบล/แขวง"
                                                            //     );
                                                            // }}
                                                            // value={values?.testAmphurCode}
                                                            value={userProfile?.address?.amphurCode ?? "-"}

                                                        >
                                                            <option defaultValue="กรุณาเลือกอำเภอ/เขต">
                                                                กรุณาเลือกอำเภอ/เขต
                                                            </option>
                                                            {testAmphur?.map((amphur) => (
                                                                <option
                                                                    key={amphur.amphurCode}
                                                                    value={amphur.amphurCode}
                                                                >
                                                                    {amphur.amphurName}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row>
                                                    <Label for="testTumbonCode" sm={2}>
                                                        ตำบล/แขวง<span className="require-input">*</span>
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="testTumbonCode"
                                                            name="testTumbonCode"
                                                            disabled
                                                            type="select"
                                                            className={
                                                                touched.testTumbonCode &&
                                                                    errors.testTumbonCode
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            // onChange={(e) => {
                                                            //     handleChange(e);
                                                            //     GetTestLocationsId(e);
                                                            // }}
                                                            // value={values?.testTumbonCode}
                                                            value={userProfile?.address?.tumbonCode ?? "-"}

                                                        >
                                                            <option defaultValue="กรุณาเลือกตำบล/แขวง">
                                                                กรุณาเลือกตำบล/แขวง
                                                            </option>
                                                            {testTumbon?.map((tumbon) => (
                                                                <option
                                                                    key={tumbon.tumbonCode}
                                                                    value={tumbon.tumbonCode}
                                                                >
                                                                    {tumbon.tumbonName}
                                                                </option>
                                                            ))}
                                                        </Input>
                                                    </Col>

                                                    <Label for="testPostCode" sm={2}>
                                                        รหัสไปรษณีย์<span className="require-input">*</span>
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            maxLength={5}
                                                            id="testPostCode"
                                                            name="testPostCode"
                                                            type="text"
                                                            disabled
                                                            className={
                                                                touched.testPostCode && errors.testPostCode
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            // value={values?.testPostCode}
                                                            value={userProfile?.address?.postCode ?? "-"}

                                                        />
                                                    </Col>
                                                </FormGroup>

                                            </div>
                                        </div>

                                        {/* ชื่อผู้ประสานงาน */}
                                        <FormGroup>
                                            <Label for="contact">
                                                ชื่อผู้ประสานงาน
                                                <span className="require-input">*</span>
                                                {/* {touched.coordinateName && errors.coordinateName ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.coordinateName}
                                                </span>
                                            ) : null} */}
                                            </Label>
                                            <Col>
                                                <Input
                                                    className={
                                                        touched.coordinateName && errors.coordinateName
                                                            ? "input-error rounded-pill text-center input-color"
                                                            : "rounded-pill text-center input-color"
                                                    }
                                                    type="text"
                                                    name="coordinateName"
                                                    id="coordinateName"
                                                    onBlur={handleBlur}
                                                    disabled
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                    }}
                                                    value={values?.coordinateName}
                                                // value={userProfile?.coordinateName}


                                                />
                                            </Col>
                                            <div className="px-3 pt-4">
                                                <FormGroup row>
                                                    <Label for="coordinatePhone" sm={2}>
                                                        โทรศัพท์<span className="require-input">*</span>
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="coordinatePhone"
                                                            name="coordinatePhone"
                                                            type="text"
                                                            className={
                                                                touched.coordinatePhone &&
                                                                    errors.coordinatePhone
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            disabled
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            value={values?.coordinatePhone}
                                                        />
                                                    </Col>

                                                    <Label for="coordinateMobile" sm={2}>
                                                        โทรศัพท์มือถือ<span className="require-input">*</span>
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="coordinateMobile"
                                                            name="coordinateMobile"
                                                            disabled
                                                            type="text"
                                                            className={
                                                                touched.coordinateMobile &&
                                                                    errors.coordinateMobile
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            value={values?.coordinateMobile}
                                                        />
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup row>
                                                    <Label for="soi" sm={2}>
                                                        โทรสาร
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="coordinateFax"
                                                            name="coordinateFax"
                                                            disabled
                                                            type="text"
                                                            className={
                                                                touched.coordinateFax && errors.coordinateFax
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            value={values?.coordinateFax}
                                                        />
                                                    </Col>

                                                    <Label for="coordinateEmail" sm={2}>
                                                        อีเมล<span className="require-input">*</span>
                                                    </Label>
                                                    <Col sm={4}>
                                                        <Input
                                                            id="coordinateEmail"
                                                            name="coordinateEmail"
                                                            disabled
                                                            type="text"
                                                            className={
                                                                touched.coordinateEmail &&
                                                                    errors.coordinateEmail
                                                                    ? "input-error rounded-pill text-center input-color"
                                                                    : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            value={values?.coordinateEmail}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </div>
                                        </FormGroup>

                                        {/* ประกาศข้อ 4 */}
                                        <FormGroup className="mt-3">
                                            {/* <Input
                                            type="radio"
                                            className={
                                                errors.announce
                                                    ? "input-error mx-2 cus-type"
                                                    : "mx-2 cus-type"
                                            }
                                            disabled={startDate < new Date() && new Date() < endDate ? false : true}
                                            name="announce"
                                            value="4"
                                            onChange={(e) => {
                                                handleChange(e)
                                                getCondition(e)
                                            }}
                                            onBlur={handleBlur}
                                            checked={values?.announce === "4"}
                                        /> */}
                                            <Label>
                                                ดำเนินการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติในสาขาตามประกาศอัตราค่าจ้างตามมาตรฐานฝีมือและมีผู้ผ่าน
                                                การทดสอบในปีที่ผ่านมา ตั้งแต่ 100 คนขึ้นไป
                                                ตามประกาศข้อ 4
                                            </Label>
                                        </FormGroup>
                                        {values?.announce === "4" ? (
                                            <div className="">
                                                <Label>กรุณากรอกเลขที่ใบอนุญาตการเป็นผู้ดำเนินการทดสอบ ตามมาตรา 24</Label>
                                                <div className="d-flex">
                                                    <Input
                                                        type="text"
                                                        name="certificate24"
                                                        {...getFieldProps("certificate24")}
                                                        value={certificate24}
                                                        className={`rounded-pill rounded-end text-center input-color ${errors?.certificate24 && touched?.certificate24 ? "input-error" : ""}`}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                            setCertificate24(e.target.value)
                                                        }}
                                                    // disabled={startDate < new Date() && new Date() < endDate ? false : true}
                                                    />
                                                    <button
                                                        type="button"
                                                        // disabled={errors.certificate24 ? true : false}
                                                        className="btn border border-1 rounded-pill rounded-start text-center input-color"
                                                        onClick={() => {
                                                            checkCertificate24() // ขอ data
                                                            checkTotalPerson24() //ขอจำนวนคนทั้งหมด
                                                            getListTestPersonAnnounce4()

                                                        }}
                                                    // disabled={startDate < new Date() && new Date() < endDate ? false : true}
                                                    >

                                                        ค้นหา
                                                    </button>
                                                </div>
                                                {certificate24Person?.map((item => (
                                                    <div className="mt-4">
                                                        <Label className="">
                                                            รวมจำนวนผู้ผ่านการทดสอบ จำนวน <span className="input-color">{item.total}</span> คน
                                                        </Label>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <Label className="w-75">
                                                                รายชื่อผู้ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติของศูนย์ทดสอบฯ
                                                                ในระบบรายงานผลผู้ผ่านการทดสอบ
                                                            </Label>
                                                            <FaSistrix className="mx-2 style-icon" onClick={ToggleModalListTestPerson} />
                                                        </div>
                                                    </div>
                                                )))}

                                                <CreateTableComponent
                                                    column={COLUMNSANNOUNCE4}
                                                    dataInput={certificate24Data}
                                                    showEntrie={false}
                                                    showPage={false}
                                                />
                                            </div>

                                        ) : null}

                                        {/* แบนไฟล์ต่างๆ */}
                                        <FormGroup className="mt-3">
                                            <Label>
                                                มีความประสงค์ขอรับเงินช่วยเหลืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน
                                                พ.ศ. 2545 เป็นจำนวนเงินทั้งสิ้น
                                                <span className="require-input">*</span>
                                                {touched.amount && errors.amount ? (
                                                    <span className="text-left text-danger px-1">
                                                        {errors.amount}
                                                    </span>
                                                ) : null}
                                            </Label>
                                            <Input
                                                id="amount"
                                                name="amount"
                                                type="text"
                                                disabled={true}
                                                className={
                                                    touched.amount && errors.amount
                                                        ? "input-error rounded-pill text-center input-color"
                                                        : "rounded-pill text-center input-color"
                                                }
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }}
                                                value={NumberWithCommas(Number(calculateAmount))}
                                            />
                                        </FormGroup>

                                        <FormGroup className="">
                                            <Label>
                                                โดยขอรับเช็คขีดคร่อมสั่งจ่ายในนาม
                                                <span className="require-input">*</span>
                                                {touched.paymentName && errors.paymentName ? (
                                                    <span className="text-left text-danger px-1">
                                                        {errors.paymentName}
                                                    </span>
                                                ) : null}
                                            </Label>
                                            <Input
                                                id="paymentName"
                                                name="paymentName"
                                                type="text"
                                                className={
                                                    touched.paymentName && errors.paymentName
                                                        ? "input-error rounded-pill text-center input-color"
                                                        : "rounded-pill text-center input-color"
                                                }
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }}
                                                value={values?.paymentName}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <Label>เอกสารอื่นๆ (ถ้ามี)</Label>
                                            <Input
                                                id="fOtherPath"
                                                name="fOtherPath"
                                                type="file"
                                                className="rounded-pill text-center input-color"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    if (e.target && e.target.files[0]) {
                                                        setFieldValue("fOtherPath", e.target.files[0]);
                                                    }
                                                }}
                                            />
                                        </FormGroup>

                                        {/* term */}
                                        <div className="d-flex">
                                            <Input
                                                type="checkbox"
                                                name="term"
                                                id="term"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }}
                                                value={values?.term}
                                                checked={values?.term}
                                            />
                                            <Label for="term" className="mx-2 customer-type">
                                                ข้าพเจ้ารับรองว่าข้อความดังกล่าวข้างต้นและเอกสารหลักฐานที่แนบคำขอถูกต้องและเป็นความจริงทุกประการ
                                            </Label>
                                        </div>
                                        <FormGroup className="d-flex justify-content-center mt-3">
                                            <button
                                                type="submit"
                                                disabled={values?.term ? false : true}
                                                className="btn-blue px-4 w-25"
                                            >
                                                ส่งคำขอ
                                            </button>
                                        </FormGroup>

                                    </Form>
                                </div>
                            ) : (
                                <Loading />
                            )}
                        </Container>
                    </>

                );
            }}
        </Formik>
    );
}
